import * as React from "react";
import Logo from "./Logo";
import { AppBar, Toolbar } from "@mui/material";
import theme from "./theme";

export default function TopBar() {
  return (
    <AppBar
      position={"static"}
      sx={{ backgroundColor: theme.palette.primary.dark }}
    >
      <Toolbar sx={{ justifyContent: "center" }}>
        <Logo maxWidth={200} />
      </Toolbar>
    </AppBar>
  );
}
